module.exports = __webpack_public_path__ + "img/company-inner.b163f8d8.jpg";